export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin-dashboard',
    name: 'adminDashboard',
    component: () => import('@/views/dashboard/adminDashboard.vue'),
  },
  {
    path: '/admin-vero',
    name: 'adminVero',
    component: () => import('@/views/dashboard/adminVero.vue'),
  },
  {
    path: '/hod-dashboard',
    name: 'HODDashboard',
    component: () => import('@/views/dashboard/HODDashboard.vue'),
  },
  
]
